import { AbstractControl, ValidationErrors } from '@angular/forms';

// Keep this rule in sync with the canonical email validation and RFC 5321:
// backend commons-validation EmailValidation.java and landingpage validators/email.ts.
const EMAIL_PATTERN =
  /^(?=.{1,64}@)[\w!#$%&'*+\-/=?^`{|}~]+(?:\.[\w!#$%&'*+\-/=?^`{|}~]+)*@[\w!#$%&'*+/=?^`{|}~]+(?:-[\w!#$%&'*+/=?^`{|}~]+)*(?:\.[\w!#$%&'*+\-/=?^`{|}~]{2,})+$/;

export function emailValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }
  const email: string = control.value;

  if (email.length > 254) {
    return { email: true };
  }
  return EMAIL_PATTERN.test(email) ? null : { email: true };
}
